
import Slidebar from "@/components/SlidebarPAtient.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "dashboard",
  components: {
    Slidebar,
  },
};
